import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/feature-requests/$requestId/")({
  staticData: {
    breadcrumb: false,
  },
  component: RequestDetailIndexRoute,
})

function RequestDetailIndexRoute() {
  return null
}
